export function realtimeApiBaseUrl(): string | undefined {
  const value = process.env.INNGEST_DEV;
  if (!value) return undefined;
  try {
    return new URL(value).href;
  } catch {
    return undefined;
  }
}
